import { render, staticRenderFns } from "./PptImageAttr.vue?vue&type=template&id=b20cb0ca&"
import script from "./PptImageAttr.vue?vue&type=script&lang=js&"
export * from "./PptImageAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/PptImageAttr.vue"
export default component.exports